import React, { useState } from 'react';
import { Button, Grid, Card, Select, InputLabel, FormControl, MenuItem, Chip, Typography } from '@mui/material';
import Image from 'material-ui-image';
import { Hidden } from '@material-ui/core';








export default function CollectionItem({ product, addToCart, loading, buttonText = "Add To Cart" }) {
  const [variant, setVariant] = useState(product.variants[0]);

  const handleOptionChange = (pos) => ({ target }) => {
    setVariant(product.variants.find(v => (
      v.option1 === (pos === 1 ? target.value : variant.option1) &&
      v.option2 === variant.option2 &&
      v.option3 === variant.option3
    )))
  }


  const handleAddToCart = ({ target }) => {
    addToCart(variant)
  }


  const { images, title, options } = product;
  return (
    <Card sx={{ p: 1 }}>
      <Grid container spacing={1} alignItems='center' justifyContent='center' >

        <Grid container item justifyContent='end' alignItems='center' spacing={2} xs={12} >
          <Grid item>
            <Typography variant='caption'><strike>{variant.compare_at_price}</strike></Typography>
          </Grid>
          <Grid item>
            <Chip sx={{ color: 'white', bgcolor: 'green' }} label={toCash(0, "FREE!")} />
          </Grid>
        </Grid>

        <Hidden mdUp>
          {images?.slice(0, 2)?.filter(Boolean)?.map((img, i, r) => img && (
            <Grid item xs={6}>
              <Image key={i} src={img.src} style={{ objectFit: 'cover' }} />
            </Grid>
          ))}
        </Hidden>

        <Hidden smDown>
          <Grid item xs={12}>
            <Image src={images[0].src} />
          </Grid>
        </Hidden>


        <Grid item xs={12}>
          <Typography >{title}</Typography>
        </Grid>

        {options?.map((option, i) => (
          <Grid item xs={12} key={i}>
            <FormControl fullWidth>
              <InputLabel>{option.name}</InputLabel>
              <Select label={option.name} variant='outlined' value={variant["option" + option.position]} onChange={handleOptionChange(option.position)} >
                {option.values.map(v => (
                  <MenuItem key={v} value={v}>{v}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        ))}

        <Grid item xs={12}>
          <Button disabled={loading} fullWidth onClick={handleAddToCart} >{buttonText}</Button>
        </Grid>
      </Grid>
    </Card>
  )
}






function toCash(amt, zeroAlt) {
  if (typeof amt === 'string') amt = Number(amt) || 0;
  if (amt === 0 && zeroAlt) return zeroAlt;
  return "$" + amt.toFixed(2)
}




